import type {RowData} from '../../types/RowData';
import {selectPreviousRows} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useGridPreviousRows(): RowData[] {
  return useEagGridSelector(selectPreviousRows);
}
